import { useState } from 'react';
import { CommonDialog, CommonDialogHeader } from '..';
import { IProduct } from '../../../types/product';
import { DeleteButton } from '../../Buttons/DeleteButton';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../types/store';
import { showNotification } from '../../../store/Reducers/NotificationSnackbarSlice';
import { CustomerAppService } from '../../../api/services/customerAppService';
import { setDisplayedProducts } from '../../../store/Reducers/CustomerAppSlice';
import { IDeleteProductDialogProps } from '../../../types/dialog';

export const DeleteProductDialog = ({ section, data }: IDeleteProductDialogProps) => {
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const { content: products } = useSelector((state: IRootState) => state.customerApp);

  const dispatch = useDispatch();

  const removeProductFromList = async () => {
    try {
      const newList = products
        ?.filter((x: IProduct) => x.iD != data.iD)
        .map((x: IProduct, index: number) => {
          return {
            sequence: index + 1,
            sku: x.sKU,
          };
        });

      const payload = {
        items: newList,
      };

      const updatedProducts = await CustomerAppService.updateProductsBySection(section, payload);
      dispatch(setDisplayedProducts(updatedProducts));
      dispatch(
        showNotification({
          message: `Successfully removed ${data.sKU} from the list.`,
        }),
      );
      setIsOpenDialog(false);
    } catch (err: any) {
      dispatch(
        showNotification({
          message: `Failed to remove product from the list. ${err?.response?.data?.message || ''}`,
          severity: 'error',
        }),
      );
    }
  };

  return (
    <>
      <DeleteButton
        onClick={() => {
          setIsOpenDialog(true);
        }}
      />
      {isOpenDialog && (
        <CommonDialog
          isOpen={isOpenDialog}
          header={
            <CommonDialogHeader
              title={'Delete'}
              onClose={() => {
                setIsOpenDialog(false);
              }}
            />
          }
          body={
            <div
              style={{
                padding: 20,
              }}
            >
              Are you sure you want to delete{' '}
              <span style={{ fontWeight: 600 }}>
                {data.sKU}-{data.name}
              </span>{' '}
              from the list?
            </div>
          }
          footer={
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: 10,
                justifyContent: 'flex-end',
              }}
            >
              <Button
                onClick={() => {
                  setIsOpenDialog(false);
                }}
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  removeProductFromList();
                }}
              >
                Yes
              </Button>
            </div>
          }
        />
      )}
    </>
  );
};
